"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowDownstreamOwnersPane = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var queries_1 = require("../../../gen-src/queries");
var OwnersGridSortProvider_1 = require("../sorting/sortProviders/OwnersGridSortProvider");
var MultiSelectionControls_1 = require("../widgets/MultiSelectionControls");
var FlowDownstreamOwnersQueryGrid_1 = require("./FlowDownstreamOwnersQueryGrid");
var FlowDownstreamOwnersPane = /** @class */ (function (_super) {
    __extends(FlowDownstreamOwnersPane, _super);
    function FlowDownstreamOwnersPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fetchAllOwnerKeys = function (client) { return __awaiter(_this, void 0, void 0, function () {
            var sliceable, items;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sliceable = this.createOwnerIdsSliceable(client);
                        return [4 /*yield*/, (0, data_catalog_shared_1.getAllFromSliceable)(sliceable)];
                    case 1:
                        items = _a.sent();
                        return [2 /*return*/, items.map(function (item) { return item.vizportalId; })];
                }
            });
        }); };
        return _this;
    }
    FlowDownstreamOwnersPane.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(data_catalog_shared_1.MultiSelectionProvider, { selectionId: this.props.flowVizportalUrlId }, function (_a) {
            var selectedKeys = _a.selectedKeys, setSelectedKeys = _a.setSelectedKeys, updateSelectionForKey = _a.updateSelectionForKey;
            return react_1.default.createElement(data_catalog_shared_1.VerticalFlexContainer, { fillFlexParent: true },
                react_1.default.createElement(data_catalog_shared_1.PaneTitle, null,
                    react_1.default.createElement(data_catalog_shared_1.HorizontalFlexContainer, null,
                        _this.props.title,
                        _this.props.rowCount != null && _this.props.rowCount > 0 ?
                            react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(MultiSelectionControls_1.MultiSelectionControls, { selectedKeys: selectedKeys, setSelectedKeys: setSelectedKeys, updateSelectionForKey: updateSelectionForKey, fetchAllKeys: _this.fetchAllOwnerKeys }),
                                react_1.default.createElement(data_catalog_shared_1.ComposeEmailPaneButton, { selectedUserIds: selectedKeys, contentType: 'flow', contentId: _this.props.flowVizportalUrlId, contentLuid: _this.props.flowLuid }))
                            : null)),
                react_1.default.createElement(OwnersGridSortProvider_1.OwnersGridSortProvider, null, function (_a) {
                    var orderBy = _a.orderBy, updateSortOrder = _a.updateSortOrder;
                    return react_1.default.createElement(FlowDownstreamOwnersQueryGrid_1.FlowDownstreamOwnersQueryGrid, { flowVizportalUrlId: _this.props.flowVizportalUrlId, selectedKeys: selectedKeys, updateSelectionForKey: updateSelectionForKey, filteredFlowOutputFieldId: _this.props.filteredFlowOutputFieldId, rowCount: _this.props.rowCount, orderBy: orderBy, updateSortOrder: updateSortOrder });
                }));
        }));
    };
    FlowDownstreamOwnersPane.prototype.createOwnerIdsSliceable = function (client) {
        if (this.props.filteredFlowOutputFieldId) {
            return new data_catalog_shared_1.GraphQLSliceable({
                queryGql: queries_1.FlowDownstreamOwnerIdsFilteredByFlowOutputFieldDocument,
                selectConnectionListResult: function (resultData) {
                    var flow = resultData.flows && resultData.flows[0];
                    var outputField = flow && flow.outputFields && flow.outputFields[0];
                    return outputField.downstreamOwnersConnection;
                },
                mapResultNode: function (node) { return node; },
            }, {
                flowVizportalUrlId: this.props.flowVizportalUrlId,
                selectedFlowOutputFieldId: this.props.filteredFlowOutputFieldId,
            }, client);
        }
        else {
            return new data_catalog_shared_1.GraphQLSliceable({
                queryGql: queries_1.FlowDownstreamOwnerIdsDocument,
                selectConnectionListResult: function (resultData) {
                    var flow = resultData.flows && resultData.flows[0];
                    return flow.downstreamOwnersConnection;
                },
                mapResultNode: function (node) { return node; },
            }, { flowVizportalUrlId: this.props.flowVizportalUrlId }, client);
        }
    };
    return FlowDownstreamOwnersPane;
}(react_1.default.Component));
exports.FlowDownstreamOwnersPane = FlowDownstreamOwnersPane;
//# sourceMappingURL=FlowDownstreamOwnersPane.js.map